﻿import DefaultApp from './defaultApp';
import datatable from './components/dataTable.vue';

const claimsApp = {
    ...DefaultApp,
    components: {
        datatable
    },
    mounted() {
        this.$refs.claims.getData();
    }
}

export default claimsApp;